import { Component, Input, SimpleChanges, OnChanges, ChangeDetectionStrategy, Output, EventEmitter, ViewChild, ElementRef } from "@angular/core"
import { Submission } from "../submissions/submission.queries"
import { submissionInContext } from "src/logic/submission-states"

@Component({
  selector: 'video-box',
  templateUrl: 'video-box.component.html',
  styleUrls: ['video-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoBoxComponent implements OnChanges {
  @Input() submission: Submission
  @Output() action: EventEmitter<VideoBoxActionEvent> = new EventEmitter<VideoBoxActionEvent>()
  @ViewChild('videoPlayer') videoPlayer: ElementRef<HTMLVideoElement>
  state: any = {
    purchaseable: false,
    awaitingEditing: false,
    purchased: false
  }
  expanded: boolean
  visibleForm: string
  editRequestPath: (string|number)[]
  deliveryOptionsPath: (string|number)[]
  deliveryOptionsNotice: string // Used in multiple places
  badgeTitle: string

  // For purchasing
  @Output() accept: EventEmitter<VideoBoxPurchaseEvent> = new EventEmitter<VideoBoxPurchaseEvent>()

  // For commenting
  feedback: 'vimeo' | 'comments' = 'vimeo'
  comments: string
  @Output() requestEdits: EventEmitter<VideoBoxCommentEvent> = new EventEmitter<VideoBoxCommentEvent>()

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.submission) {
      const submission = changes.submission.currentValue as Submission
      this.state.purchaseable = submissionInContext(submission, 'purchaseable')
      this.state.awaitingEditing = submissionInContext(submission, 'awaiting_editing')
      this.state.purchased = submissionInContext(submission, 'purchased')
      this.visibleForm = submission.visibleForm
      this.expanded = submission.expanded
      this.editRequestPath = ['/', 'dashboard', this.submission.customerId, 'topics', 'request', this.submission.request.id, 'edit']
      this.deliveryOptionsPath = ['/', 'dashboard', this.submission.customerId, 'delivery_options']
      this.comments = submission.comments
      this.badgeTitle = submission.state.split('_').join(' ')
    }
  }

  onAction(action: string): void {
    this.action.emit({ submission: this.submission, action })
  }

  onAccept(): void {
    this.accept.emit({ submission: this.submission })
  }

  onRequestEdits(comments: string): void {
    this.requestEdits.emit({ submission: this.submission, comments })
  }

  public playVideo(): void {
    this.videoPlayer.nativeElement.play()
  }
}

export interface VideoBoxActionEvent {
  submission: Submission
  action: string
}

export interface VideoBoxCommentEvent {
  submission: Submission
  comments: string
}

export interface VideoBoxPurchaseEvent {
  submission: Submission
}
